import { render, staticRenderFns } from "./VAutocompleteTextarea.vue?vue&type=template&id=552ef66e&scoped=true&"
import script from "./VAutocompleteTextarea.vue?vue&type=script&lang=js&"
export * from "./VAutocompleteTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VAutocompleteTextarea.vue?vue&type=style&index=0&id=552ef66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ef66e",
  null
  
)

export default component.exports